import React, { useState, useEffect } from 'react';
import { CheckboxContainer, Check, Label } from './checkbox-style';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
  size?: string;
  label?: string;
  disabled?: boolean;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = React.forwardRef(
  ({ checked, disabled, className, id, onChange, size, label }, ref) => {
    const [isChecked, setIsChecked] = useState(checked);
    const attrId = id !== '' ? { id } : {};

    useEffect(() => {
      setIsChecked(checked);
    }, [checked]);

    return (
      <CheckboxContainer
        onClick={() => {
          const value = !isChecked;
          setIsChecked(value);
          onChange(value);
        }}
        onKeyPress={() => {
          const value = !isChecked;
          setIsChecked(value);
          onChange(value);
        }}
        disabled={disabled}
      >
        <Check
          ref={ref}
          className={`${className} ${isChecked ? 'is-checked' : ''}`}
          role='checkbox'
          aria-checked='false'
          tabIndex='0'
          size={size}
        >
          <input {...attrId} type='checkbox' style={{ display: 'none' }} />
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
            <path d='M6,6 v8 h16' fill='none' transform='rotate(-45, 12, 12)' />
          </svg>
        </Check>
        <Label size={size}>
          {label}
          {checked}
        </Label>
      </CheckboxContainer>
    );
  }
);

Checkbox.defaultProps = {
  disabled: false,
  className: '',
  id: '',
  size: '1rem'
};

export default Checkbox;
